import { BlockListSection, DetailSection, Resume } from '@sr/types';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Box } from '../../ui';
import SectionItems from './SectionItems';
import SidebarRow from './SidebarRow';

type Props = {
  resume: Resume;
  sectionId: string;
  title: string;
  isAbout?: boolean;
  index: number;
  closeSidebar?: () => void;
  setSectionHovered: (arg0: boolean) => void;
};

const SidebarSection = ({
  resume,
  title,
  sectionId,
  isAbout,
  index,
  closeSidebar,
  setSectionHovered,
}: Props) => {
  return (
    <Box key={sectionId}>
      {/* @ts-ignore */}
      <Draggable draggableId={sectionId} index={index} type="SECTION">
        {(provided) => (
          <Box
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <Box {...provided.dragHandleProps}>
              <SidebarRow
                dragHandleProps={provided.dragHandleProps}
                id={sectionId}
                title={title}
                closeSidebar={closeSidebar}
                setSectionHovered={setSectionHovered}
              />
            </Box>
            <SectionItems
              section={
                resume.sections[sectionId] as DetailSection | BlockListSection
              }
              closeSidebar={closeSidebar}
            />
          </Box>
        )}
      </Draggable>
    </Box>
  );
};

SidebarSection.defaultProps = {
  isAbout: false,
};

export default SidebarSection;
